module.exports = __webpack_public_path__ + "static/media/rym.ac990355958c4646a6fa00da557dd88d.svg";